module.exports = __webpack_public_path__ + "images/delete-trash-f56494f2.svg";